import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { ErpSyncBatchesPage } from '@pages/erp-sync-batches';

export const Route = createFileRoute('/$locale/_authenticated/erp-sync/migration-batches')({
  component: ErpSyncBatchesRoute,
});

function ErpSyncBatchesRoute() {
  const { locale } = Route.useParams();
  const navigate = useNavigate();

  return (
    <ErpSyncBatchesPage
      onOpenEvidence={(batchId) => {
        void navigate({
          to: '/$locale/erp-sync/evidence',
          params: { locale },
          search: { focus: `run:${batchId}` },
        });
      }}
    />
  );
}
